import { useEffect } from 'react'
import { usePostHog } from 'posthog-js/react'
import { trpc } from '@/config/trpc'

/** Mirrors the user's plan onto their PostHog person, so any insight, funnel,
 *  cohort or survey can filter on `plan_tier` / `plan_source` (e.g. "AppSumo
 *  buyers who published a post"). identify() only carries the auth fields, and
 *  the backend never sets person properties, so without this AppSumo users
 *  could not be segmented at all. */
export function usePlanPersonProperties() {
  const posthog = usePostHog()
  const { data: subscription } = trpc.userSubscription.get.useQuery()

  const tier = subscription?.isSubscribed ? subscription.tier : subscription ? 'free' : undefined
  const source = subscription?.isSubscribed
    ? subscription.source
    : subscription
      ? 'none'
      : undefined

  useEffect(() => {
    if (!tier || !source) return
    posthog.setPersonProperties({ plan_tier: tier, plan_source: source })
  }, [tier, source, posthog])
}
